var exports = {
  "U": "x127c5a35--253f5b--buttons",
  "r": "x127c5a35--253f5b--delete-button",
};

module.exports = exports;
